<!-- Header footer section start -->
<section id="header-footer">
    <div class="row">
        <div class="col-12 mb-1">
            <div class="content-header" [innerHTML]="lmsData?.title"></div>
            <!-- <p class="content-sub-header mb-1" [innerHtml]="lmsData?.description | highlightText: searchTerm"></p> -->
        </div>
    </div>
    <!-- <span class="badge badge-pill badge-primary mb-1 mr-2" *ngFor='let data of lmsData'
        (click)='selectTag(t)'>{{t.name}}</span> -->
    <div class="row match-height" *ngIf="lmsData?.content1">
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="lmsData?.content1 | markdown ">
                        </p>
                    </div>
                    
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(lmsData.content1)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
     
    </div>
    <div class="row match-height" *ngIf="lmsData?.content2">
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="lmsData?.content2 | markdown ">
                        </p>
                    </div>
                    
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(lmsData.content2)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
     
    </div>
    <div class="row match-height" *ngIf="lmsData?.content3">
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="lmsData?.content3 | markdown ">
                        </p>
                    </div>
                    
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(lmsData.content3)'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <iframe *ngIf="lmsData?.video1" [src]="lmsData?.video1 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================2=========================== -->
<div class="row match-height" *ngIf="lmsData?.content4">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content4 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content4)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content5">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content5 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content5)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content6">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content6 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content6)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe *ngIf="lmsData?.video2" [src]="lmsData?.video2 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================3=========================== -->
<div class="row match-height" *ngIf="lmsData?.content7">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content7 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content7)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content8">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content8 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content8)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content9">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content9 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content9)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe  *ngIf="lmsData?.video3" [src]="lmsData?.video3 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================4=========================== -->
<div class="row match-height" *ngIf="lmsData?.content10">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content10 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content10)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content11">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content11 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content11)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content12">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content12 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content12)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe  *ngIf="lmsData?.video4" [src]="lmsData?.video4 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================5=========================== -->
<div class="row match-height" *ngIf="lmsData?.content13">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content13 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content13)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content14">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content14 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content14)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content15">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content15 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content15)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe  *ngIf="lmsData?.video5" [src]="lmsData?.video5 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================4=========================== -->
<div class="row match-height" *ngIf="lmsData?.content16">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content16 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content16)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content17">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content17 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content17)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content18">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content18 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content18)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe  *ngIf="lmsData?.video6" [src]="lmsData?.video6 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================4=========================== -->
<div class="row match-height" *ngIf="lmsData?.content19">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content19 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content19)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content20">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content20 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content20)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content21">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content21 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content21)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe  *ngIf="lmsData?.video7" [src]="lmsData?.video7 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================4=========================== -->
<div class="row match-height" *ngIf="lmsData?.content22">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content22 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content22)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content23">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content23 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content23)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content24">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content24 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content24)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe  *ngIf="lmsData?.video8" [src]="lmsData?.video8 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================4=========================== -->
<div class="row match-height" *ngIf="lmsData?.content25">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content25 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content25)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content26">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content26 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content26)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content27">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content27 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content27)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe  *ngIf="lmsData?.video9" [src]="lmsData?.video9 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!-- =====================4=========================== -->
<div class="row match-height" *ngIf="lmsData?.content28">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content28 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content28)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content29">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content29 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content29)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
 
</div>
<div class="row match-height" *ngIf="lmsData?.content30">
    <div class="col-lg-12 col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="card-body">
                    <p class="card-text"
                        [innerHtml]="lmsData?.content30 | markdown ">
                    </p>
                </div>
                
            </div>
            <div class="card-footer text-muted pt-0">
                <span class="float-right">
                    <span class="badge badge-pill badge-primary mb-1 mr-2"
                        (click)='copyToClipboard(lmsData.content30)'>Copy</span>
                </span>
            </div>
        </div>
    </div>
</div>
<iframe *ngIf="lmsData?.video10" [src]="lmsData?.video10 | safe"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

</section>
<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>
<!-- Header footer section end -->

<!-- <ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Verify Password</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="mb-3">
                <label for="dateOfBirth">Enter Password</label>
                <div class="input-group">
                    <input class="form-control" placeholder="password" type="password" name="dp" [(ngModel)]='password'>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)='detail()'>Save</button>
    </div>
</ng-template> -->
<!--Modal with Default options ends-->